async function initialize(paymentForm, stripe) {

    const clientSecret = paymentForm.dataset.clientSecret;

    const appearance = {
        theme: 'stripe',
    };

    let elements = stripe.elements({appearance, clientSecret});

    const paymentElement = elements.create('payment', {
        defaultValues: {
            billingDetails: {
                email: paymentForm.dataset.email,
                name: paymentForm.dataset.fname,
                phone: paymentForm.dataset.phone,
                /*address: {
                    postal_code: '10001',
                    country: 'US',
                },*!/*/
            },
        },
    });

    paymentElement.mount('#payment-element');

    return elements;
}

function showMessage(message) {
    const el = document.getElementById('card-errors');
    el.classList.remove('d-none');
    el.textContent = message;
}

async function checkStatus(stripe) {
    const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');

    if (clientSecret) {
        const {error, paymentIntent} = await stripe.retrievePaymentIntent(clientSecret);

        if (error) {
            // Display error.message in your UI.
            showMessage(error.message);
        } else {
            // The payment has succeeded. Display a success message.
            switch (paymentIntent.status) {
                case 'succeeded':
                    // Show a success message to your customer
                    showMessage('Payment succeeded');
                    break;

                case  'processing' :
                    // Show a success message to your customer
                    showMessage('Payment processing');
                    break;

                case  'requires_payment_action' :
                    // Show a success message to your customer
                    showMessage('Payment requires action');
                    break;
                default:
                    // Show an error message to your customer
                    showMessage('Payment failed');
                    break;

            }
        }
    }
}

async function handleSubmit(event, stripe, paymentForm, elements) {
    event.preventDefault();
    setLoading(true);
    
    const {paymentIntent, error} = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: paymentForm.dataset.returnUrl,
            }
        }
    );

    if (error) {
        // Display "error.message" to the user...
        if (error.type === 'validation_error' || error.type === 'card_error') {
            showMessage(error.message);
        } else {
            showMessage('Payment failed: An unexpected error occurred.');
        }
    } else {
        // The payment has been processed!
        if (paymentIntent.status === 'succeeded') {
            // Show a success message to your customer
            // There's a risk of the customer closing the window before callback
            // execution. Set up a webhook or plugin to listen for the
            // payment_intent.succeeded event that handles any business critical
            // post-payment actions.

        }
    }

    setLoading(false);
}
function setLoading(isLoading) {
    if (isLoading) {
        // Disable the button and show a spinner
        document.querySelector("#submit").disabled = true;
        document.querySelector("#spinner").classList.remove("d-none");
        document.querySelector("#button-text").classList.add("d-none");
    } else {
        document.querySelector("#submit").disabled = false;
        document.querySelector("#spinner").classList.add("d-none");
        document.querySelector("#button-text").classList.remove("d-none");
    }
}

export function initPayments() {

    let paymentForm = document.getElementById("payment-form");
    if (!paymentForm) {
        return;
    }

    setTimeout(async function () {
        const stripe = window.Stripe(paymentForm.dataset.publicKey);

        const elements = await initialize(paymentForm, stripe)

        await checkStatus(stripe)

        paymentForm.addEventListener('submit', async (event) => await handleSubmit(event, stripe, paymentForm, elements));

    }, 100);
}